<template>
    <ul class=" lots">
        <li v-for="(l, i) in lotsList" :key="i + l.lot_number">
            <p class="lots__title"><b>Лот {{l.lot_number}}:</b> {{l.purchase_title}}</p>
            <div class="lots__info">
                <p v-if="l.lot_contracts_sum || l.lot_purchase_price">
                    <b>Начальная (максимальная) цена контракта:</b> 
                    {{moneyFormat(l.lot_contracts_sum || l.lot_purchase_price, 2)}} <i class="uk-icon-rub"></i>
                </p>
                <div v-if="l.contracts && l.contracts.length" class="lots__contracts">
                    <div v-if="l.contracts.length > 1">
                        <b>Контракты:</b>
                        <ul>
                            <li v-for="(c, i) in l.contracts" :key="i">
                                <a 
                                    v-if="links.contract_number[law]" 
                                    :href="links.contract_number[law] + c.contract_number" 
                                    class="blue-red-hover-text"
                                    target="_blank"
                                >
                                    {{c.contract_number}}
                                </a>
                                <span v-else>{{c.contract_number}}</span>
                                <span v-if="c.contract_date_sign"> от {{dateParser(l.contracts[0].contract_date_sign)}}</span>
                                <span v-if="c.contract_sum"> на сумму {{moneyFormat(l.contracts[0].contract_sum, 2)}} <i class="uk-icon-rub"></i></span>
                                <span v-if="c.contract_stage_title"> ({{c.contract_stage_title}})</span>
                            </li>
                        </ul>
                    </div>
                    <p v-if="l.contracts.length === 1">
                        <b>Контракт:</b>
                        <a 
                            v-if="links.contract_number[law]" 
                            :href="links.contract_number[law] + l.contracts[0].contract_number" 
                            class="blue-red-hover-text"
                            target="_blank"
                        >
                            {{l.contracts[0].contract_number}}
                        </a>
                        <span v-else>{{l.contracts[0].contract_number}}</span>
                        <span v-if="l.contracts[0].contract_date_sign"> от {{dateParser(l.contracts[0].contract_date_sign)}}</span>
                        <span v-if="l.contracts[0].contract_sum"> на сумму {{moneyFormat(l.contracts[0].contract_sum, 2)}} <i class="uk-icon-rub"></i></span>
                        <span v-if="l.contracts[0].contract_stage_title"> ({{l.contracts[0].contract_stage_title}})</span>
                    </p>
                </div>
                <div v-if="l.suppliers && l.suppliers.length" class="lots__suppliers">
                    <template v-if="l.suppliers.length === 1">
                        <b>Победитель:</b>
                        <span v-if="l.suppliers[0].ogrn || l.suppliers[0].inn">
                            <card-link :ogrn="l.suppliers[0].ogrn || l.suppliers[0].inn">
                                {{l.suppliers[0].name}}
                            </card-link>
                            <tooltip class="stay-on-row" :ogrn="l.suppliers[0].ogrn || l.suppliers[0].inn" />
                        </span>
                        <span v-else>{{l.suppliers[0].name}}</span>
                    </template>
                    <template v-if="l.suppliers.length > 1">
                        <b>Победители:</b>
                        <ul>
                            <li v-for="(s, i) in l.suppliers" :key="i + s.ogrn">
                                <span v-if="s.ogrn || s.inn">
                                    <card-link :ogrn="s.ogrn || s.inn">{{s.name}}</card-link>
                                    <tooltip class="stay-on-row" :ogrn="s.ogrn || s.inn" />
                                </span>
                                <span v-else>{{s.name}}</span>
                            </li>
                         </ul>
                    </template>
                </div>
                <div v-if="l.participants && l.participants.length" class="lots__participants">
                    <template v-if="l.participants.length === 1">
                        <b>Участник:</b>
                        <span v-if="l.participants[0].ogrn || l.participants[0].inn">
                            <card-link :ogrn="l.participants[0].ogrn || l.participants[0].inn">
                                {{l.participants[0].name}}
                            </card-link>
                            <tooltip class="stay-on-row" :ogrn="l.participants[0].ogrn || l.participants[0].inn" />
                            <span v-if="l.participants[0].price">
                                Предложенная сумма: {{moneyFormat(l.participants[0].price, 2)}} <i class="uk-icon-rub"></i>
                            </span>
                        </span>
                    </template>
                    <template v-if="l.participants.length > 1">
                        <b>Участники:</b>
                        <ul>
                            <li v-for="(p, i) in l.participants" :key="i + p.ogrn">
                                <span v-if="p.ogrn || p.inn">
                                    <card-link :ogrn="p.ogrn || p.inn">{{p.name}}</card-link>
                                    <tooltip class="stay-on-row" :ogrn="p.ogrn || p.inn" />
                                </span>
                                <span v-else>{{p.name}}</span>
                                <span v-if="p.price">
                                    Предложенная сумма: {{moneyFormat(p.price, 2)}} <i class="uk-icon-rub"></i>
                                </span>
                                <span v-if="p.is_excluded "> (Исключен)</span>
                            </li>
                        </ul>
                    </template>
                </div>
                <div v-if="l.products && l.products.length" class="lots__products">
                    <b>Предмет контракта:</b>
                    <ul>
                        <li class="product" v-for="(pr, i) in l.products" :key="i + pr.name">
                            <app-accordion>
                                <span class="product__title" slot="title">{{pr.name}}</span>
                                <ul class="product__descr no_print" slot="content">
                                    <li v-if="pr.code"><b>Код позиции:</b> {{pr.code}}</li>
                                    <li v-if="pr.okei_title"><b>Единица измрения:</b> {{pr.okei_title}}</li>
                                    <li v-if="pr.price"><b>Цена за единицу:</b> {{moneyFormat(pr.price, 2)}} <i class="uk-icon-rub"></i></li>
                                    <li v-if="pr.quantity"><b>Количество:</b> {{pr.quantity}}</li>
                                    <li v-if="pr.sum_price"><b>Сумма:</b> {{moneyFormat(pr.sum_price, 2)}} <i class="uk-icon-rub"></i></li>
                                </ul>
                            </app-accordion>
                        </li>
                    </ul>
                </div>
                <app-accordion 
                    v-if="(l.purchases && l.purchases.length) || (l.contracts && l.contracts.length) || (l.protocols && l.protocols.length)" 
                    class="lots__additional_info additional_info no_print"
                >
                    <b slot="title">Дополнительная информация</b>
                    <div class="additional_info__content" slot="content">
                        <!-- ЗАКУПКА -->
                        <template v-if="l.purchases && l.purchases.length">
                            <div v-for="(pur, i) in l.purchases" :key="i + pur.purchase_number" class="additional_info__card">
                                <h4>Закупка</h4>
                                <p v-if="pur.purchase_number">
                                    <b>Номер извещения: </b>
                                    <a 
                                        class="blue-red-hover-text" 
                                        :href="links.purchase_number[law] + pur.purchase_number" 
                                        target="_blank"
                                    >
                                        {{pur.purchase_number}}
                                    </a>
                                </p>
                                <p v-if="pur.purchase_title">
                                    <b>Наименование закупки: </b>
                                    <span>{{pur.purchase_title}}</span>
                                </p>
                                <p v-if="pur.purchase_sum">
                                <b>Сумма закупки: </b>
                                    <span>{{moneyFormat(pur.purchase_sum, 2)}} <i class="uk-icon-rub"></i></span>
                                </p>
                                <p v-if="pur.purchase_type_title">
                                    <b>Способ размещения закупки: </b>
                                    <span>{{pur.purchase_type_title}}</span>
                                </p>
                                <p v-if="pur.purchase_date_add">
                                    <b>Дата размещения извещения: </b>
                                    <span>{{dateParser(pur.purchase_date_add)}}</span>
                                </p>
                            </div>
                        </template>
                        <!-- КОНТРАКТЫ -->
                        <template v-if="l.contracts && l.contracts.length">
                            <div v-for="(c, i) in l.contracts" :key="i + c.contract_number" class="additional_info__card">
                                <h4>Контракт</h4>
                                <p v-if="c.contract_number"> 
                                    <b>Реестровый номер контракта: </b>
                                    <span>{{c.contract_number}}</span>
                                </p>
                                <p v-if="c.contract_number_real">
                                    <b>Номер контракта: </b>
                                    <span>{{c.contract_number_real}}</span>
                                </p>
                                <p v-if="c.contract_date_sign">
                                    <b>Дата заключения контракта: </b>
                                    <span>{{c.contract_date_sign}}</span>
                                </p>
                                <p v-if="law">
                                    <b>Федеральный закон №: </b>
                                    <span>{{law}}-ФЗ</span>
                                </p>
                                <p v-if="c.contract_sum">
                                    <b>Цена контракта: </b>
                                    <span>{{moneyFormat(c.contract_sum, 2)}} <i class="uk-icon-rub"></i></span>
                                </p>
                                <p v-if="c.contract_stage_title">
                                    <b>Стадия исполнения: </b>
                                    <span>{{c.contract_stage_title}}</span>
                                </p>
                                <p v-if="c.contract_date_exec_end">
                                    <b>Дата окончания исполнения контракта: </b>
                                    <span>{{dateParser(c.contract_date_exec_end)}}</span>
                                </p>
                            </div>
                        </template>
                        <!-- ПРОТОКОЛ -->
                        <template v-if="l.protocols && l.protocols.length">
                            <div v-for="(p, i) in l.protocols" :key="i + p.protocol_number" class="additional_info__card">
                                <h4>Протокол</h4>
                                <p v-if="p.protocol_number">
                                    <b>Номер протокола: </b>
                                    <span>{{p.protocol_number}}</span>
                                </p>
                                <p v-if="p.protocol_type_title">
                                    <b>Название: </b>
                                    <span>{{p.protocol_type_title}}</span>
                                </p>
                                <p v-if="p.protocol_date">
                                    <b>Дата подписания протокола: </b>
                                    <span>{{dateParser(p.protocol_date)}}</span>
                                </p>
                            </div>
                        </template>
                    </div>
                </app-accordion>
            </div>
        </li>
    </ul>
</template>

<script>
import cardLink from '@/components/ui/cardLink.vue'
import tooltip from '@/components/ui/tooltip.vue'
import appAccordion from '@/components/ui/appAccordion/appAccordion.vue'

export default {
    props: {
        lotsList: {
            type: Array,
            default: []
        },
        law: {
            type: Number
        },
        links: {
            type: Object,
            default: {}
        }
    },
    components: {
        cardLink,
        tooltip,
        appAccordion
    }
}
</script>

<style lang="sass" scoped>

@import 'styles/global-variables'

.stay-on-row
    display: inline-block

.lots
    li
        p
            margin: 0
            padding: 0
    &__contracts
        ul
            margin: 7px 0
            font-size: 13px
        li
            margin: 7px 0
            list-style: disc
    &__info
        padding-left: 30px
        display: flex
        flex-direction: column
        gap: 10px
        margin-top: 10px
    &__products
        .product
            list-style: disc
            margin: 7px 0
            &__title
                color: #3f556b !important
                font-size: 14px !important
                font-weight: 600 !important
                font-style: italic !important
            &__descr
                padding: 0
                li
                    color: #555
                    font-size: 13px
                    padding: 0
                    b
                        font-style: italic
    &__participants
        ul
            font-size: 13px
            margin: 0
            li
                margin: 7px 0
                list-style: disc
    .additional_info
        &__content
            display: flex
            flex-wrap: wrap
            gap: 30px
            padding: 15px 5px
            

        &__card
            @include small-card
            p
                margin: 5px 0
                b
                    color: #555
                    font-style: italic
            
</style>